export default __webpack_public_path__ + "static/media/msg_illus.a7fd59ce.svg";